import React, { Component }  from 'react';
import '../../style.css';
import {fetchPost} from "../../static/util/fetch";
import {
    Button,
    Card,
    Form, Input, Menu, message,
    Modal,
    PageHeader,
    Space,
    Table, Tag, Select
} from "antd";
import {
    CaretUpOutlined,
    DeleteOutlined,
    EditOutlined, MailOutlined
} from "@ant-design/icons";
import CompanyPaceMain from "../CompanyPaceMain";
const { Column } = Table;
const Option = Select.Option;

class UserList extends Component {
    constructor(props) {
        super(props);
        this.state={
            user:[],
            tabBar:1,
            company:[],
            companyName:'',
            companyId:0,
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加公司弹窗状态
            delete_visible:false,//删除弹窗状态
            edit_field_visible:false,//修改技术领域弹窗状态
            ifUp_visible:false,
            deleteId: 0,//待删除公司id
            editId: 0,
            upId:0,
            userId:'',
            username:'',
            phone:'',
            password:'',
            area:'',
            loading:false,
        }
        this.hideModal = this.hideModal.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true
        }))
        fetchPost(global.constants.getUsersByAdminArea,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            user:res.data,
                            loading:false
                        }))
                    }else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info(res.msg).then();
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            edit_visible:false,
            delete_visible:false,
            ifUp_visible:false,
        }))
    }
    handleEnter = (e)=>{
         const value = e.id;
        fetchPost(global.constants.adminGetCompanyList,{userId:value})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            company:res.data,
                        }))
                    }
                    else{
                        message.info('该用户未绑定公司').then();
                        this.setState(()=>({
                            company:[],
                        }))
                    }
                }
            )
    }
    seePace(e){
        const value = e
        fetchPost(global.constants.getCompany,{id:value})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            companyName: res.data.companyName,
                            companyId:value,
                            tabBar:2
                        }))
                    }})
    }
    handleEditList(e){
        const value = e.id;
        let params = {
            userId:e.id,
            username:e.username,
            phone:e.phone,
            password:e.password,
            area:e.area,
        }
        this.setState(()=>({
            editId:value,
        }))
        fetchPost(global.constants.adminUpdateUser,params)
            .then(
                res =>{
                    console.log(res.data)
                    if(res.code === 200){
                        this.setState(()=>({
                            userId:res.data.id,
                            username:res.data.username,
                            phone:res.data.phone,
                            password:res.data.password,
                            area:res.data.area,
                            edit_visible:true,
                        }))
                    }
                    if(res.code === -1){
                        console.log("获取待修改人员信息失败")
                    }
                }
            )
    }
    updateUser(){
        const regPassword =/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/;
        const newResPassword = regPassword.test(this.state.password);
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(this.state.phone)
        if(newResPhone === false ){
            message.error("请检查该手机号是否真实！").then()
        }else{
            if(this.state.password !== null && newResPassword === false){
                message.error("请注意密码格式！").then()
            }
            else {
                let params = {
                    userId: this.state.editId,
                    username: this.state.username,
                    phone: this.state.phone,
                    password: this.state.password,
                    area: this.state.area,
                }
                fetchPost(global.constants.adminUpdateUser, params)
                    .then(
                        res => {
                            console.log(res)
                            if (res.code === 200) {
                                message.success(res.msg).then()
                                this.setState(() => ({
                                    edit_visible: false
                                }))
                                fetchPost(global.constants.getUsersByAdminArea, {})
                                    .then(
                                        res => {
                                            if (res.code === 200) {
                                                this.setState(() => ({
                                                    user: res.data,
                                                }))
                                            } else {
                                                message.info(res.msg).then()
                                            }
                                        }
                                    )//更新后重新获取
                            }
                            if (res.code === -1) {
                                message.error(res.msg).then()
                            }
                            if (res.code === null) {
                                console.log("返回值为空，修改失败")
                            }
                        }
                    )
            }
        }
    }
    handleDeleteList(e){
        const value = e.id;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value,
        }))
    }
    deleteUser(){
        fetchPost(global.constants.adminDeleteUser,{userId:this.state.deleteId})
            .then(
                res => {
                    if(res.code === 200){
                        message.success('删除用户信息成功！').then();
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        fetchPost(global.constants.getUsersByAdminArea,{})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            user:res.data,
                                        }))
                                    }
                                    else{
                                        message.info(res.msg).then()
                                    }
                                }
                            )//更新后重新获取
                    }
                    if(res.code === -1){
                        message.error(res.msg).then()
                    }
                }
            )
    }
    handleUp(e){
        this.setState(()=>({
            ifUp_visible:true,
            upId:e.id,
        }))
    }
    Up(e){
        fetchPost(global.constants.userRightRaising,{userId:this.state.upId})
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("升为管理员成功").then()
                        this.setState(()=>({
                            ifUp_visible:false,
                        }))
                        fetchPost(global.constants.getUsersByAdminArea,{})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            user:res.data,
                                        }))
                                    }else{
                                        message.info(res.msg).then();
                                    }
                                }
                            )
                    }else{
                        message.info(res.msg).then();
                        this.setState(()=>({
                            user:[]
                        }))
                    }
                }
            )
    }
    handleChangeTabBar = (tabBar) => {
        this.setState({
            tabBar: tabBar
        })
    }
    render() {
        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="用户列表"
                            subTitle={"默认显示该管理员所属地区的所有用户"}
                        >
                        </PageHeader>
                    </div>
                    <Menu
                        theme="light"
                        selectedKeys={[this.state.tabBar]}
                        mode="horizontal">
                        <Menu.Item key='1' onClick={this.handleChangeTabBar.bind(this, 1)} icon={<MailOutlined />}>
                            用户列表
                        </Menu.Item>
                        <Menu.Item key='2' onClick={this.handleChangeTabBar.bind(this, 2)} >
                            {this.state.companyName}
                        </Menu.Item>
                    </Menu>
                    {
                        this.state.tabBar === 1 && (
                            <Space direction="vertical" className="content-style">
                                <Card bordered={true} style={{border: 'solid  1px #7F9DB9'}}>
                                    <Table dataSource={this.state.user} loading={this.state.loading}
                                           onHeaderRow={() => {
                                               return {className: "list-column-style"}
                                           }}>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">序号</p>}
                                            width="80"
                                            render={
                                                (text, record, index) => (`${index + 1}`)}/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">用户名</p>}
                                            dataIndex="username"
                                            key="username"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">账号</p>}
                                            dataIndex="phone"
                                            key="phone"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">地区</p>}
                                            dataIndex="area"
                                            key="area"/>
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">身份</p>}
                                            key="action"
                                            render={(text, record) => (
                                                record.identity === 1 &&
                                                <Tag color="green" className="Tag_style">管理员</Tag>,
                                                record.identity === 2 &&
                                                <Tag color="blue" className="Tag_style">普通用户</Tag>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">权限</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Button
                                                        type="primary"
                                                        icon={<CaretUpOutlined/>}
                                                        onClick={this.handleUp.bind(this, record)}
                                                    >升为管理员</Button>
                                                </Space>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">查看进度</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Select showSearch
                                                            placeholder="请选择公司"
                                                            optionFilterProp="children"
                                                            notFoundContent="无法找到"
                                                            searchPlaceholder="输入关键词"
                                                            onClick={this.handleEnter.bind(this, record)}
                                                            onSelect={this.seePace.bind(this)}
                                                            // value={this.state.companyName}
                                                    >
                                                        {
                                                            this.state.company.map(item => (
                                                                <Option
                                                                    key={item.id}
                                                                    value={item.id}
                                                                >
                                                                    {item.companyName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Space>
                                            )}
                                        />
                                        <Column
                                            align="center"
                                            title={<p className="list-column-style">操作</p>}
                                            key="action"
                                            render={(text, record) => (
                                                <Space size="middle">
                                                    <Button
                                                        type="primary"
                                                        icon={<EditOutlined/>}
                                                        onClick={this.handleEditList.bind(this, record)}
                                                    >编辑</Button>
                                                    <Button
                                                        type="primary"
                                                        icon={<DeleteOutlined/>}
                                                        onClick={this.handleDeleteList.bind(this, record)}
                                                    >删除</Button>
                                                </Space>
                                            )}
                                        />
                                    </Table>
                                </Card>
                            </Space>
                        )
                    }
                    {
                        this.state.tabBar === 2 &&
                            <CompanyPaceMain companyId={this.state.companyId} companyName={this.state.companyName}/>
                    }
                    <Modal
                        visible={this.state.edit_visible}
                        title={'修改用户信息'}
                        onOk={this.updateUser}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.updateUser}>
                                提交
                            </Button>,
                        ]}
                    >
                        <Form>
                            <Form.Item label="用户名" name="userName" >
                                <Input
                                    defaultValue={this.state.username}
                                    onChange={(e) => this.usernameChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="账号" name="phone" >
                                <Input
                                    defaultValue={this.state.phone}
                                    onChange={(e) => this.phoneChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="密码" name="password" >
                                <Input
                                    placeholder={'不输入数据即不更改密码'}
                                    defaultValue={this.state.password}
                                    onChange={(e) => this.passwordChange(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item label="地区" name="area" >
                                <Input
                                    defaultValue={this.state.area}
                                    onChange={(e) => this.areaChange(e.target.value)}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>
                    <Modal
                        visible={this.state.delete_visible}
                        title={'温馨提示'}
                        onOk={this.deleteUser}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.deleteUser}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定删除该用户吗？</div>
                    </Modal>
                    <Modal
                        visible={this.state.ifUp_visible}
                        title={'温馨提示'}
                        onOk={this.Up.bind(this)}
                        onCancel={this.hideModal}
                        destroyOnClose
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                                取消
                            </Button>,
                            <Button key="submit" type="primary"  onClick={this.Up.bind(this)}>
                                确定
                            </Button>,
                        ]}
                    >
                        <div>确定将该用户升为管理员吗？</div>
                    </Modal>
                </div>
            </div>
        )
    }
    usernameChange(e){
        this.setState({
            username:e
        })
    }
    phoneChange(e){
        this.setState({
            phone:e
        })
    }
    passwordChange(e){
        this.setState({
            password:e
        })
    }
    areaChange(e){
        this.setState({
            area:e
        })
    }
}
export default UserList;